import { Artist } from '../types';
import { ARTISTS } from '../constants';
import { supabase } from '../lib/supabase';

export const getArtists = (): Artist[] => {
  return ARTISTS; // For build-time sitemap generation
};

export const getArtistsForClient = async (): Promise<Artist[]> => {
  const { data, error } = await supabase.from('artists').select('*');
  if (error) {
      console.error('Error fetching artists from Supabase:', error);
      return ARTISTS; // Fallback to constants only on error
  }
  return data as Artist[];
};

export const getArtistById = async (id: string): Promise<Artist | undefined> => {
    const { data, error } = await supabase.from('artists').select('*').eq('id', id).single();
    if (error) {
        return ARTISTS.find(a => a.id === id);
    }
    return data as Artist;
};

export const addArtist = async (artist: Omit<Artist, 'id'>): Promise<Artist> => {
  const newArtist = { ...artist, id: `custom-${Date.now()}` };
  const { data, error } = await supabase.from('artists').insert([newArtist]).select().single();
  if (error) {
      console.error('Error adding artist:', error);
      throw error;
  }
  return data as Artist;
};

export const updateArtist = async (id: string, updatedData: Partial<Artist>): Promise<Artist | null> => {
    const { data, error } = await supabase.from('artists').update(updatedData).eq('id', id).select().single();
    if (error) {
        console.error('Error updating artist:', error);
        return null;
    }
    return data as Artist;
};

export const deleteArtist = async (id: string): Promise<void> => {
  const { error } = await supabase.from('artists').delete().eq('id', id);
  if (error) {
      console.error('Error deleting artist:', error);
  }
};

export const importDefaultArtists = async (): Promise<void> => {
    const { count, error: countError } = await supabase.from('artists').select('*', { count: 'exact', head: true });
    if (countError) {
        console.error('Error checking existing artists:', countError);
        throw new Error('Failed to check existing artists');
    }
    
    if (count && count > 0) {
        throw new Error('Database already contains artists. Please delete them first to re-import.');
    }

    const { error } = await supabase.from('artists').insert(ARTISTS);
    if (error) {
        console.error('Error importing default artists:', error);
        throw new Error('Failed to import default artists');
    }
};

export const isAuthenticated = (): boolean => {
    return typeof window !== 'undefined' && localStorage.getItem('astralvibe_admin_auth') === 'true';
};

export const login = (password: string): boolean => {
    if (password === 'admin123') {
        localStorage.setItem('astralvibe_admin_auth', 'true');
        return true;
    }
    return false;
};

export const logout = (): void => {
    localStorage.removeItem('astralvibe_admin_auth');
};




